import en from './locale/en';
import fr from './locale/fr';
import es from './locale/es';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';

export default {
  en,
  fr,
  es,
  pt_BR,
  pt,
};
